import * as React from 'react';

import { cn, TouchButton } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';
import { LucideExternalLink } from 'lucide-react';

import { ItemFieldProps } from '../_types';

import { $openCatalyticModal } from '~/modules/trade/_state/materialsInterface.state';
import { useTranslations } from '~/modules/trade/i18n/useTranslations';

//
// ⚛️ ⚛️ ⚛️ EDIT ITEM BUTTON FIELD ⚛️ ⚛️ ⚛️
//
export const EditItemButtonField: React.FC<ItemFieldProps> = ({
  lineItem,
  disabled,
  onClick,
}) => {
  // Translation
  const t = useTranslations();

  // Atoms
  const openCatalyticModal = useSetAtom($openCatalyticModal);

  // Callbacks
  const handleEdit = React.useCallback(() => {
    if (onClick) {
      onClick();
    } else {
      openCatalyticModal({
        mode: 'edit',
        selectedItemId: lineItem.itemId,
        lineItemId: lineItem.id,
      });
    }
  }, [onClick, lineItem.id, lineItem.itemId, openCatalyticModal]);

  return (
    <TouchButton
      variant="ghost"
      color="neutral"
      onPress={handleEdit}
      isDisabled={disabled}
      aria-label={t.scaleTicketPro.itemsInterface.editItem}
      className={cn('@EditItemButtonField', 'max-h-[44px]')}
      isSelected={false}
    >
      <LucideExternalLink className="size-4" />
    </TouchButton>
  );
};
